import request from '@/utils/request'

const basePath = 'api/specification/public/list'

/**
 * 获取规格列表
 * @returns {*}
 */
export function getSpecificationList() {
    return request({
        url: `${basePath}`,
        method: 'GET'
    })
}